import { Card } from "@certn/cascadia-react";

import { LegacyCommentSection } from "../components/LegacyCommentSection";

interface Props {
  comments: any[];
  mutate: any;
}

export function LegacyCommentSectionTab(props: Props) {
  const { comments, mutate } = props;
  return (
    <Card testID="legacy-comment-section" type="large" responsive>
      <LegacyCommentSection comments={comments} mutate={mutate} />
    </Card>
  );
}
